import { SESSION_HINT_COOKIE } from "./session-hint-header";

export function hasSessionHintCookie(): boolean {
  return document.cookie
    .split(";")
    .some((part) => part.trim() === `${SESSION_HINT_COOKIE}=1`);
}

export function clearSessionHintCookie(): void {
  document.cookie = `${SESSION_HINT_COOKIE}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax`;
}
